export const GET_SELLER_INFOS = 'GET_SELLER_INFOS';
type State = Readonly<{
  email: string | null | undefined;
  salesmanID: string | null | undefined;
}>;
const initialState: State = {
  email: null,
  salesmanID: '',
};
export const sellerInfoReducer = (state: State = initialState, action: Action<any>) => {
  switch (action.type) {
    case GET_SELLER_INFOS: {
      const { sellerInfo } = action.payload;
      return {
        email: sellerInfo?.email || state.email,
        salesmanID: sellerInfo?.salesmanID || state.salesmanID,
      };
    }

    default:
      return state;
  }
};
